export default "__VITE_ASSET__iWDqK_GT__"